/** Push a pageview event to gtag */ export function pageview(url) {
    var _window_gtag, _window;
    (_window_gtag = (_window = window).gtag) === null || _window_gtag === void 0 ? void 0 : _window_gtag.call(_window, 'event', 'page_view', {
        page_path: url
    });
}
/** Push a custom event to gtag */ export function trackEvent(eventName, params) {
    var _window_gtag, _window;
    (_window_gtag = (_window = window).gtag) === null || _window_gtag === void 0 ? void 0 : _window_gtag.call(_window, 'event', eventName, params);
}
